import React from 'react'
import intl from 'react-intl-universal'

import { ComposerSettings } from '~/types'

type Props = ComposerSettings['proofreaders']['proLexis'] & {
  onChange: (
    proLexisSettings: ComposerSettings['proofreaders']['proLexis']
  ) => void
}

const ProLexisSettings: React.FC<Props> = (props) => {
  /*
    <input /> elements currently use defaultValue + onBlur to prevent
    the entire Angular settings module from re-rendering on each keystroke.

    This can be changed to the more standard value + onChange once settings
    is rewritten in React.
  */
  return (
    <div>
      <div className="mb-3">
        <label htmlFor="proLexis-api-key">
          {intl.get('ProLexisSettings.labels.apiKey')}
        </label>
        <input
          type="text"
          className="form-control"
          id="proLexis-api-key"
          defaultValue={props.apiKey}
          onBlur={(event) => {
            props.onChange({
              apiKey: event.target.value,
              url: props.url,
            })
          }}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="proLexis-url">
          {intl.get('ProLexisSettings.labels.url')}
        </label>
        <input
          type="text"
          className="form-control"
          id="proLexis-url"
          defaultValue={props.url}
          onBlur={(event) => {
            props.onChange({
              url: event.target.value,
              apiKey: props.apiKey,
            })
          }}
        />
      </div>
    </div>
  )
}

export default ProLexisSettings
